import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="drawing"
export default class extends Controller {
  static targets = ['canvas']

  connect() {
    this.canvasContext = this.canvasTarget.getContext('2d')

    this.activeColour = 'black'
    this.dragging = false
    this.cursorPoint = { x: 0, y: 0 }

    this.boundOnMouseDownHandler = this.onMouseDownHandler.bind(this)
    this.boundOnMouseMoveHandler = this.onMouseMoveHandler.bind(this)
    this.boundOnMouseUpHandler = this.onMouseUpHandler.bind(this)
    this.boundOnDocumentCanvasTouchHandler = this.onDocumentCanvasTouchHandler.bind(this)

    this.canvasTarget.addEventListener('mousedown', this.boundOnMouseDownHandler)
    this.canvasTarget.addEventListener('mousemove', this.boundOnMouseMoveHandler)
    this.canvasTarget.addEventListener('mouseup', this.boundOnMouseUpHandler)
    this.canvasTarget.addEventListener('mouseout', this.boundOnMouseUpHandler)

    this.canvasTarget.addEventListener('touchstart', this.boundOnMouseDownHandler)
    this.canvasTarget.addEventListener('touchend', this.boundOnMouseUpHandler)
    this.canvasTarget.addEventListener('touchmove', this.boundOnMouseMoveHandler)

    document.body.addEventListener('touchstart', this.boundOnDocumentCanvasTouchHandler, { passive: false })
    document.body.addEventListener('touchend', this.boundOnDocumentCanvasTouchHandler, { passive: false })
    document.body.addEventListener('touchmove', this.boundOnDocumentCanvasTouchHandler, { passive: false })
  }

  disconnect() {
    this.canvasTarget.removeEventListener('mousedown', this.boundOnMouseDownHandler)
    this.canvasTarget.removeEventListener('mousemove', this.boundOnMouseMoveHandler)
    this.canvasTarget.removeEventListener('mouseup', this.boundOnMouseUpHandler)
    this.canvasTarget.removeEventListener('mouseout', this.boundOnMouseUpHandler)

    this.canvasTarget.removeEventListener('touchstart', this.boundOnMouseDownHandler)
    this.canvasTarget.removeEventListener('touchend', this.boundOnMouseUpHandler)
    this.canvasTarget.removeEventListener('touchmove', this.boundOnMouseMoveHandler)

    document.body.removeEventListener('touchstart', this.boundOnDocumentCanvasTouchHandler)
    document.body.removeEventListener('touchend', this.boundOnDocumentCanvasTouchHandler)
    document.body.removeEventListener('touchmove', this.boundOnDocumentCanvasTouchHandler)
  }

  clear() {
    this.canvasContext.clearRect(0, 0, 100000, 100000)
  }

  getLocationFrom(e) {
    const location = { x: 0, y: 0 }

    if (e.constructor.name === 'TouchEvent') {
      const bounds = e.target.getBoundingClientRect()
      const touch = e.targetTouches[0]

      location.x = touch.clientX - bounds.left
      location.y = touch.clientY - bounds.top
    } else {
      location.x = e.offsetX
      location.y = e.offsetY
    }

    return location;
  }

  onMouseDownHandler(e) {
    this.dragging = true

    const location = this.getLocationFrom(e)
    this.cursorPoint.x = location.x
    this.cursorPoint.y = location.y

    this.canvasContext.lineWidth = 1
    this.canvasContext.lineCap = 'round'
    this.canvasContext.filter = 'blur(1px)'
    this.canvasContext.beginPath()
    this.canvasContext.moveTo(this.cursorPoint.x, this.cursorPoint.y)
    this.canvasContext.strokeStyle = this.activeColour
  }

  onMouseUpHandler(_e) {
    this.dragging = false
  }

  onMouseMoveHandler(e) {
    if(!this.dragging) return

    const location = this.getLocationFrom(e)
    this.canvasContext.lineTo(location.x, location.y)
    this.canvasContext.stroke()
  }

  onDocumentCanvasTouchHandler(e) {
    if (e.target === this.canvasTarget) e.preventDefault()
  }
}
